<h1>Forgot Password</h1>

<form [formGroup]="myForm" (ngSubmit)="requestPasswordReset()">
  <div class="form-group">
    <label for="email" >Email</label>
    <input
      type="email"
      formControlName="email"
      class="form-control"
      id="email"
      name="email"
      required
    />
    <div *ngIf="myForm.get('email').invalid && (myForm.get('email').dirty || myForm.get('email').touched)">
      <div *ngIf="myForm.get('email').errors.required">
        Email is required.
      </div>
      <div *ngIf="myForm.get('email').errors.email">
        Invalid email format.
      </div>
    </div>
  </div>
  <button [disabled]="myForm.invalid" type="submit" class="btn btn-primary">Request password</button>
</form>
